import React from 'react';

import { Inertia } from '@inertiajs/inertia';
import { useRemember } from '@inertiajs/inertia-react';
import _ from 'lodash';
import Link from '@/Shared/Link';
import Table from "react-bootstrap/Table"
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faPen, faTrashAlt } from '@fortawesome/free-solid-svg-icons'

import SearchFilter from '@/Shared/SearchFilter';
import Pagination from '@/Shared/Pagination';
import LoadingButton from '@/Shared/LoadingButton';
import DeleteButton from '@/Shared/DeleteButton';

import {upperFirst, idGen} from '@/utils';

import {getColumnTable} from '@/Shared/FuncComp';
import { Row, ListGroup, Col } from 'react-bootstrap';
import Icon from '@/Shared/Icon';
import {PREFIX_NAME_MANAGER_ROUTING} from '@/constants/Site'

class ListManager extends React.Component {
	static statebase = {
		//modalOptions: {}
		//variant = 
		modalType: '',
	}
	
	state = {...ListManager.statebase,
	
	}
	
	constructor(props) {
		super(props);
		//if (!this.state.list) this.state.list = props.list;
	}
	
	componentDidUpdate (prevProps, prevState, snap) {
		if (this.state.showModal!==prevState.showModal && !this.state.showModal) {
			this.onClosedModal();
		}
		/*if (this.props.list?.page && this.withLoadMore() && 
			this.props.list?.page!==prevProps.list?.page
			//_.isEqual(this.props.list, prevProps.list)
		) {
			console.log('change page: from', prevProps.list?.page, 'to', this.props.list?.page);
			this.setState((p)=>({
				list: {...this.props.list, data: [...p.list?.data, ...this.props.list?.data]}
			}));
		}*/
		if (this.componentDidUpdateExtend) this.componentDidUpdateExtend(prevProps, prevState, snap);
	}
	
	keyName = "id";
	
	getKey = () => {
		return ListManager.handler(this, '$', 'keyName');
	}
	
	getDefList = () => this.props.list;

	getList = () => {
		return (!this.withLoadMore() ? this.getDefList() : this.state.list)||{};
	}
	
	getData = () => {
		return Array.isArray(this.getList()) ? this.getList() : (this.getList().data||[]);
	}
	
	getPagLinks = () => this.getList().links||[];
	
	//static modalFreeTitle = ({base}={}) => base||''
	
	getRouteEdit = () => {
		if (!this.isResource()) return '';
		return this.getRoutePrefix()+this.getRouteMain()+'.edit';
	}
	
	getRouteMain = () => {
		return ListManager.handler(this, '$', 'route')||''
	}
	
	isRouteManager = () => {
		return !!ListManager.handler(this, '$', 'routeManager')
	}
	
	getRoutePrefix = () => {
		return ListManager.handler(this, '$', 'routePrefix')||
			(this.isRouteManager() ? PREFIX_NAME_MANAGER_ROUTING||'' : '')
	}
	
	getRouteBase = () => {
		return ListManager.handler(this, '$', 'routeBase')||''
	}
	
	getRouteBaseId = () => {
		return ListManager.handler(this, '$', 'routeBaseId')||''
	}

	isResource = () => {
		return !!ListManager.handler(this, '$', 'resource', ['props', ''])
	}
	
	getRouteIndex = () => {
		return this.getRoute()+(this.isResource() && !this.isItem() ? ".index" : "");
	}
	
	getRoute = () => {
		const base = this.getRouteBase();
		return this.getRoutePrefix()+(base && !this.isItem()?base+".":"")+this.getRouteMain();
	}

	itemId = () => ListManager.handler(this, '$', 'itemId', ['props', 'state'])

	isItem = () => !!this.itemId()
	
	temp = {}
	
	getCustomItemProps = () => {
		const custom = ListManager.handler(this, '$', 'customItemProps', ['temp']);
		return custom ;
	}
	
	getSelected = () => {
		const custom = ListManager.handler(this, '$', 'selected', ['temp', 'state']);
		return custom;
	}
	
	static modalTitleCustomer = 'modal$Title'
	
	static handler = (_this, customer, typer, whereIn=['temp', 'props', '']) => {
		/*_this.temp[customer.replace(/\$/g, upperFirst(typer))] || _this.props[customer.replace(/\$/g, upperFirst(typer))] || _this[customer.replace(/\$/g, upperFirst(typer))]*/
		let result;
		whereIn.some(val=>{
			const handlerName = customer.replace(/^(.+)\$/g, "$1"+upperFirst(typer)).replace(/^\$/, typer);
			result = val ? _this[val] && _this[val][handlerName] : _this[handlerName];
			return !!result
		})
		return result;
	}
	
	getModalTitle = ({modalType=this.state.modalType,
		onlyBase
	}={}) => {
		let base = '';
		switch (modalType) {
			case 'delete':
				base = "Confirmar eliminación";
				break;
			case 'edit':
				base = "Editando elemento";
				break;
		}
		const custom = ListManager.handler(this, ListManager.modalTitleCustomer, modalType);
		if (onlyBase || !custom) return base;
		const options = {manager: this, base, modalType};
		return custom(options);
	}
	
	Item = () => {
		const inner = 'Item no establecido';
		const columns = ListManager.handler(this, '$', 'columns', ['props', ''])||[]
		switch (this.getVariant()) {
			case ListManager.VARIANT_TABLE:
				return <tr>
					<td colSpan={columns.length}>
						{inner}
					</td>
				</tr>;
		}
		return null;
	}
	
	static VARIANT_TABLE = 'table'

	static VARIANT_BLOQUE = 'bloque'

	static VARIANT_LISTA = 'lista'
	
	static DEF_VARIANT = ListManager.VARIANT_TABLE
	
	getDefaultVariant = () => ListManager.DEF_VARIANT;
	
	getVariant = () => {
		return ListManager.handler(this, '$', 'variant', ['state', 'props'])||this.getDefaultVariant();
	}
	
	getItemElement = ({modalType/*=this.state.modalType*/, variant=this.getVariant()}={}) => {
		const custom = (modalType && 
				ListManager.handler(this, '$', modalType+upperFirst(variant)+'Item') ||
				ListManager.handler(this, '$', modalType+'Item')
			) || 
			ListManager.handler(this, '$', variant+'Item') || 
			ListManager.handler(this, '$', 'Item');
		return custom;
	}
	
	//static modalFreeBody = ({base}={}) => base||null
	
	static modalBodyCustomer = 'modal$Body'

	getAdder = () => ListManager.handler(this, '$', 'add', ['props', '']);
	
	withAdder = () => !!this.getAdder();
	
	getModalBody = ({modalType=this.state.modalType, Item,
		selected=this.getSelected(), withExtraProps, customProps=this.getCustomItemProps(),
		routeMain=this.getRouteMain(), keyName=this.getKey(), onlyBase
	}={}) => {
		if (!Item) Item = this.getItemElement({modalType});
		const options = {manager: this, CurrItem: Item, modalType};
		const itemDefProps = {inModal: true, modalType}
		const variant = this.getVariant();
		let base = {};
		switch (modalType) {
			case 'delete':
				base.Item = Item;
				base.props = {...base.props, ...itemDefProps}
				break;
		}
		const custom = ListManager.handler(this, ListManager.modalBodyCustomer, modalType);
		const extraProps = withExtraProps ?
			ListManager.handler(this, '$', modalType+'ExtraItemProps') : undefined;
		if (selected && base.Item) {
			const getItemInner = (sel) => {
				const ItemInner = sel.Item || base.Item;
				const propsItem =  {...sel, ...base.props, ...extraProps} 
				return <ItemInner {...propsItem}
					{...(typeof customProps==='function' ? customProps(sel) : customProps)}
					key={'item-'+routeMain+"-"+sel[sel.keyName||keyName]}
				/>
			}
			base.getItemInner = getItemInner;
			if (Array.isArray(selected)) {
				base.inner = selected.map(sel=>getItemInner(sel));
			} else {
				base.inner = getItemInner(selected)
			}
			if (variant=='table') {
				const columns = this.getColumsTable();
				const idxAction = this.getIndexActionColumn();
				base.inner = this.getTableList({items: base.inner,
					columns: columns.filter((_, idx)=>idx!=idxAction)
				});
			}
		}
		if (!custom) return base.inner||null;
		if (onlyBase) return base;
		return custom({...options, base})
	}
	
	static modalFooterCustomer = 'modal$Footer'
	
	getModalFooter = ({modalType=this.state.modalType,
		ruta=this.getRouteMain(), keyName=this.getKey(), selected=this.getSelected(), onlyBase, 
	}={}) => {
		const options = {modalType, manager: this};
		let base = {close}
		const {CloseButton, ModalButton} = this;
		switch (modalType) {
			case 'delete':
				base.closeBtn = true;
				base.closeProps = {children: 'Cancelar'};
				base.mainBtn = !!(selected && Object.values(selected).length);
				base.mainProps = {children: 'Eliminar', variant: "danger", onClick: (e)=>{
					this.deleteHandler({selected, ruta, keyName})
				}}
		}
		if (!base.inner) base.inner = <>
			{base.closeBtn && <CloseButton {...base.closeProps} />}
			{base.mainBtn && <ModalButton {...base.mainProps} />}
		</>
		const custom = ListManager.handler(this, ListManager.modalFooterCustomer, modalType);
		if (!custom) return base.inner;
		if (onlyBase) return base;
		return custom({...options, base});
	}

	getOnSuccesDestroy = () => {
		const onSuccess = this.attrs('', 'onSuccessDestroy');
		const autoCloseModalOnDestroy = !this.attrs('', 'noAutoCloseModalOnDestroy');
		const new_state = {};
		if (autoCloseModalOnDestroy) new_state.showModal = false;
		return () => {
			if (onSuccess) {
				onSuccess({manager: this, new_state});
			} else {
				this.setState(new_state);
			}
		}
	}

	getOnlyOnDestroy = () => this.attrs('', 'onlyOnDestroy');
	
	deleteHandler = ({selected=this.getSelected(), ruta=this.getRouteMain(), keyName=this.getKey()}={}) => {
		let data = {};
		let key, id;
		if (selected) {
			if (Array.isArray(selected)) {
				data = {ids: selected.map(sel=>{
					key = sel.keyName||keyName;
					return {id: sel.id, [key]: sel[key]}
				})};
				id = data.ids[0].id;
			} else {
				key = selected.keyName||keyName
				id = selected.id;
				if (key!='id') data.id = {[key]: sel[key]};
			}
			const onSuccess = this.getOnSuccesDestroy();
			const only = this.getOnlyOnDestroy();
			Inertia.delete(route(ruta, id), {
				data,
				onSuccess,
				only,
			});
		}
	}
	
	ModalButton = ({children, ...props}) => {
		return <Button variant="secondary" {...props}>
			{children||"Cerrar"}
		</Button>
	}
	
	closeModal = () => {
		this.setState({showModal: false}, () => {
			//this.onClosedModal();
		});
	}
	
	onClosedModal = () => {
		this.temp = {};
		this.setState({modalType: ''})
	}
	
	CloseButton = (props) => {
		const {ModalButton} = this;
		return <ModalButton {...props} onClick={this.closeModal} />
	}
	
	//showDefMoreBtn = () => true;
	
	handleColumnBaseProps = ({className, ...props}={}) => {
		className = "px-6 pt-4 pb-4"+(className?" "+className:"")
		return {className, ...props}
	}

	getIndexActionColumn = () => {
		const columns = this.getColumsTable()
		let idx = this.attrs('$', 'idxColumnAction', ['props', '']);
		switch (typeof idx) {
			case 'boolean':
				return (columns?.length||0) - 1;
			case 'number':
				return idx;
			default:
				return -1;
		}
	}

	getColumsTable = () => this.attrs('$', 'columns', ['props', ''])||[];
	
	getColumnsTableList = ({columns}={}) => {
		if (!columns) columns = this.getColumsTable();
		return columns.map((col, idx)=>getColumnTable({
			col, idx, handleBaseProps: this.handleColumnBaseProps
		}));
	}
	
	getBodyTableList = ({data=this.getData(), items}={}) => {
		if (!items) items = this.getEleItems({data});
		/*const Item = this.getItemElement();
		const filas = list.map((itm,pos)=><Item {...itm} pos={pos} 
			key={'itm-tbl-'+this.getRouteMain()+"-"+itm[itm.keyName||this.getKey()]} 
		/>)*/
		return items;
	}
	
	static ceroItemsText = 'No se encontraron elementos.';
	
	getTableList = ({columns, data, items}={}) => {
		const filas = this.getBodyTableList({data, items});
		const headCnt = this.getColumnsTableList({columns});
		const bodyCnt = !filas || (Array.isArray(filas) && !filas.length) ? <tr>
          <td className="border-t px-6 py-4" colSpan={headCnt.length}>
            {ListManager.ceroItemsText}
          </td>
        </tr> : filas;
		const table = <Table className="w-full whitespace-no-wrap" hover>
			<thead>
              <tr className="text-left font-bold">
                {headCnt}
              </tr>
            </thead>
            <tbody>
				{bodyCnt}
            </tbody>
		</Table>
		return <div className="bg-white rounded shadow overflow-x-auto">
			{table}
		</div>
	}
	
	customPropsItems = () => this.props.customProps
	
	pasarPropsComoItem = () => !!this.props.pasarPropsComoItem

	getEleItems = ({
		data=this.getData(), variant=this.getVariant(), 
		customProps=this.customPropsItems(),
		Item = this.getItemElement()
	}={}) => {
		// const Item = this.getItemElement();
		const items = data.filter(itm=>!itm.hideOnList).map((itm,pos)=>{
			const withFnCustom = typeof customProps==="function"
			const extraProps = withFnCustom ? customProps({item:itm, pos}) : customProps;
			const baseProps = !withFnCustom ? (this.pasarPropsComoItem() ? {item: itm} : itm ) : undefined
			if (this.isResource()) baseProps.routeMain = this.getRouteMain();
			return <Item 
				{...baseProps} pos={pos} manager={this}
				key={'itm-'+variant+'-'+this.getRouteMain()+"-"+itm[itm.keyName||this.getKey()]} 
				{...extraProps} 
			/>
		})
		return items
	}

	/* getBloques = ({data=this.getData()}={}) => {
		const Item = this.getItemElement();
		const bloques = data.map(itm=>{
			<Item
		})
	} */

	baseWhereInAttrs = ['temp', 'props', '']

	attrs = (customer, typer, whereIn=this.baseWhereInAttrs) => ListManager.handler(this, customer, typer, whereIn);

	getContentItemsProps = ({variant=this.getVariant()}={}) => {
		return this.attrs('$', variant+'CntProps');
	}

	getBloquesCnt = () => {
		const items = this.getEleItems();
		const cntProps = this.getContentItemsProps();
		return <Row {...cntProps}>
			{!items || (Array.isArray(items) && !items.length) ? 
				<Col>
					{ListManager.ceroItemsText}
				</Col>
			: items}
		</Row>
	}
	
	getListaVariantCnt = () => {
		const items = this.getEleItems();
		const cntProps = this.getContentItemsProps();
		return <ListGroup variant="flush" {...cntProps}>
			{!items || (Array.isArray(items) && !items.length) ? 
				<ListGroup.Item>
					{ListManager.ceroItemsText}
				</ListGroup.Item>
			: items}
		</ListGroup>
	}
	
	getViewList = ({variant=this.getVariant(), options}={}) => {
		let view = null;
		switch (variant) {
			case ListManager.VARIANT_TABLE:
				view = this.getTableList();
				break;
			case ListManager.VARIANT_BLOQUE:
				view = this.getBloquesCnt();
				break;
			case ListManager.VARIANT_LISTA:
				view = this.getListaVariantCnt();
				break;
			default:
				view = <div>No está disponible esta variante para la lista</div>
				break
		}
		return view;
	}
	
	mounted = false;
	
	componentDidMount () {
		this.mounted = true;
		if (this.componentDidMountExtend) this.componentDidMountExtend();
	}
	
	componentWillUnmount() {
		this.mounted = false;
	}
	
	isMounted = () => this.mounted;
	
	handleClose = () => {
		if (this.isMounted()) {
			this.setState({showModal: false});
		}
	}

	getDeleteMark = () => <Icon
		name="trash"
		className="flex-shrink-0 w-3 h-3 text-gray-400 fill-current ml-2"
	/>

	destroyItem = (props) => {
		// console.log(props);
		this.setState({modalType: 'delete', showModal: true, selected: props});
	}
	
	ActionsCell = ({actions = {edit: true}, ...props}) => {
		return <>
			{actions.edit && <Button as={Link} href={route(this.getRouteEdit(), props.id)} variant="info">
				<FontAwesomeIcon icon={faPen} />
			</Button>}
			{actions.delete && <DeleteButton onDelete={()=>this.destroyItem(props)}>
				<FontAwesomeIcon icon={faTrashAlt} />
			</DeleteButton>}
		</>
	}
	
	WithModal = ({children, modalProps, noCnt, ...props}) => {
		const {state, handleClose} = this;
		const modal = <Modal show={state.showModal} 
			onHide={handleClose} centered {...modalProps}
		>
			<Modal.Header closeButton>
				<Modal.Title>{this.getModalTitle()}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{this.getModalBody()}
			</Modal.Body>
			<Modal.Footer>
				{this.getModalFooter()}
			</Modal.Footer>
		</Modal>
		const inner = <>{children}{/*this.showDefMoreBtn() && this.getEleGetMoreButton()*/}{modal}</>
		return noCnt ? inner : <div {...props}>
			{inner}
		</div>
	}

	withNoFilter = () => !!ListManager.handler(this, '$', 'noFilter', ['props', ''])
	
	getName = () => ListManager.handler(this, '$', 'name', ['props', ''])

	getAddRoute = () => {
		const ruta = this.getRoute();
		let addRoute = this.isResource() ? (ruta+'.create') : ''
		if (!addRoute) {
			const adder = this.getAdder();
			switch (typeof adder) {
				case 'object':
					addRoute = adder['route'];
					break;
			}
		}
		return addRoute || ruta;
	}

	noHasHeader = () => !!ListManager.handler(this, '$', 'noHeader', ['props', ''])
	
	getCurrentPage = () => this.getList()?.page||0;
	
	getLastPage = () => this.getList()?.last||0;
	
	canLoadMore = ({
		current=this.getCurrentPage(), last=this.getLastPage()
	}={}) => current < last && current > 0;
	
	loadMoreCallback = ({current=this.getCurrentPage(), last=this.getLastPage()}={}) => {
		if (!this.canLoadMore({current, last})) return;
		//const data = this.getData();
		if (!this.state.loadingMore) this.setState({loadingMore: true}, ()=>{
			Inertia.reload({
				replace: true,
				data: {page: current+1},
				only: [...this.attrs('$', 'onlyLoadMore')],
				onFinish: () => {
					this.setState({loadingMore: false});
				},
				headers: {
					'X-Inertia-Load-More-Page': true
				}
			});
		});
	}
	
	LoadMoreBtn = ({children='Cargar más', ...props}) => {
		const current = this.getCurrentPage();
		const last = this.getLastPage();
		if (!this.canLoadMore({current, last})) return null;
		return <LoadingButton variant="secondary" {...props} loading={this.state.loadingMore}
			onClick={()=>this.loadMoreCallback({current, last})}
		>
			{children}
		</LoadingButton>
	}
	
	withLoadMore = () => !!this.attrs('$', 'loadMore')
	
	getFilterProps = () => this.attrs('$', 'filterProps');
	
	renderBase = ({withModalProps, beforeList, ...props}=this.props) => {
		const viewlist = this.getViewList();
		const {WithModal, LoadMoreBtn} = this;
		const [data, setData] = useRemember(null, this.getID());
		const [currData, setCurrData] = React.useState(null);
		const defList = this.getDefList();
		const page = this.getDefList()?.page||0;
		const withLoadMore = this.withLoadMore();
		/*const currData = Object.keys(data||{}).filter(key=>key<=page).reduce((carry, key)=>{
			carry[key] = data[key];
			//carry.splice(carry.length, 0, ...data[key]);
			return carry;
		}, {});*/
		React.useEffect(()=>{
			//console.log('updated defList', defList, withLoadMore)
			if (defList?.page && withLoadMore) {
				setData((p)=>{
					return {...p, [defList.page]: defList.data}
				});
			}/* else {
				console.log('No load more', !withLoadMore);
			}*/
		}, [defList, withLoadMore]);
		React.useEffect(()=>{
			if (data) setCurrData(Object.keys(data||{}).filter(key=>key<=page).reduce((carry, key)=>{
				//carry[key] = data[key];
				carry.splice(carry.length, 0, ...data[key]);
				return carry;
			}, []));
		}, [data])
		React.useEffect(()=>{
			//console.log('curr',currData);
			//if (page) {
				/*const lastData = [];
				Object.keys(currData||{}).sort().forEach(key=>{
					lastData.splice(lastData.length, 0, ...data[key]);
				});*/
				if (currData) this.setState({list: {...defList, data: currData}});
			//}
		}, [currData])
		return <WithModal {...withModalProps}>
			{!this.noHasHeader() && <div className="mb-6 flex items-center">
		      {!this.withNoFilter() && <SearchFilter {...this.getFilterProps()} />}
		      <div className="ml-auto">
				  {props.rightNav}
		  		      {this.withAdder() && <Button as={Link} className="btn-indigo" href={route(this.getAddRoute(), this.isResource() && this.getRouteBase() ? this.getRouteBaseId() : undefined )}>
		  		        <FontAwesomeIcon icon={faPlus} />
		  		        <span className="hidden md:inline ml-2"> {this.getName()}</span>
		  		      </Button>}
			  </div>
		    </div>}
		    {beforeList}
			{viewlist}
			{!this.withLoadMore() ? <Pagination links={this.getPagLinks()} /> : <div
				className="d-flex justify-content-center"
			>
				<LoadMoreBtn />
			</div>}
		</WithModal>
	}
	
	identificador = location.pathname;
	
	getID = () => this.attrs('$', 'identificador');
	
	render () {
		const {renderBase: RenderBase} = this
		/*React.useEffect(()=>{
			setList();
			console.log('');
		}, [page]);*/
		return <RenderBase {...this.props} />;
	}
}

export {ListManager}

const ListManagerBase = (props) => {
	return <ListManager {...props}/>
}

export default ListManager;
